import EChartsReact from 'echarts-for-react';
import React, { FC, useEffect, useState } from 'react';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { ChartTools } from '@/presentation/components/chart-tools';
import { addToCompareList } from '@/presentation/pages/memory/analytics/trend/compare/compare-store';
import { DisplayItem, getChartOptionStats, getChartOptionStatsForCombine } from '@/presentation/pages/traffic/analytics/trend/chatr-option';
import { IGetDashboardDataRsp, MetricSubType, MetricType, TimeType } from '@/proto/metric';
interface IProps {
  metricType: MetricType;
  metricSubType?: MetricSubType;
  fields: Record<string, any>;
  token: string;
  timeWindow: TimeType;
  showTools?: boolean;
  showCount?: boolean;
  chartData?: IGetDashboardDataRsp;
  displayGroups?: DisplayItem[];
  unit?: number;
}

export const TrendChart: FC<IProps> = (props: IProps) => {
  const {
    metricType,
    metricSubType,
    fields,
    token,
    timeWindow,
    showTools = true,
    showCount = true,
    chartData,
    displayGroups,
    unit,
  } = props;
  const [loading, setLoading] = useState(true);
  const [option, setOption] = useState({});

  useEffect(() => {
    if (!token) {
      return;
    }

    const getOption = async () => {
      setLoading(true);
      let option;
      if (chartData && displayGroups && displayGroups?.length > 1) {
        option = await getChartOptionStatsForCombine(
          chartData,
          displayGroups!,
          timeWindow,
          unit,
        );
      } else {
        option = await getChartOptionStats(metricSubType!, timeWindow, token, showCount);
      };
      setOption(option);
      setLoading(false);
    };
    getOption();
  }, [token, metricSubType, chartData, unit, displayGroups]);

  return <>
    {showTools && <ChartTools
      isHiddenCompare
      title={'趋势分析'}
      pgId={PAGE_ID.net.analytics}
      pgName={'流量指标分析'}
      metricType={metricType}
      option={option}
      addToCompareList={() => addToCompareList(fields, metricType, metricSubType)}
      disabled={loading}
    />}
    <EChartsReact
      style={{ height: 400 }}
      option={option}
      notMerge={true}
      showLoading={loading}
    />
  </>;
};
